<template>
  <div>
    <profile-card title="Profile">
      <template v-slot:actions>
        <a :href="'/user/' + user.username">Preview</a>
      </template>
      <form v-on:submit.prevent="submit">

        <v-field title="Avatar" :error="error('avatar')">
          <img :src="thumbnail" class="tw-w-36 tw-h-36 tw-rounded tw-object-cover">
          <div class="tw-flex tw-mt-4 tw-items-center tw-space-x-4">
            <button type="button" v-on:click.prevent="$refs.avatar.click()" class="tw-rounded tw-bg-light tw-border tw-shadow tw-py-3 tw-px-6 tw-font-bold cursor:tw-border-blue cursor:tw-text-blue">Change Photo</button>
            <button type="button" v-on:click.prevent="removeAvatar" class="tw-rounded tw-bg-light tw-border tw-shadow tw-py-3 tw-px-6 tw-font-bold cursor:tw-border-red cursor:tw-text-red">Remove Photo</button>
          </div>
          <input v-on:change="setAvatar" type="file" class="tw-hidden" ref="avatar"/>
        </v-field>

        <v-field title="Username" required :error="error('username')">
          <input type="text" class="tw-form-input" v-model="form.username"/>
          <div v-if="!loadingUsernameAvailability && form.username !== user.username && form.username !== ''">
            <div :class="`${usernameAvailabilityResponse.available ? 'tw-text-green' : 'tw-text-red'}`" class="tw-font-semibold tw-mt-2">{{usernameAvailabilityResponse.message}}</div>
          </div>
        </v-field>

        <v-field title="First Name" required :error="error('first_name')">
          <input type="text" class="tw-form-input" v-model="form.first_name"/>
        </v-field>

        <v-field title="Last Name" required :error="error('last_name')">
          <input type="text" class="tw-form-input" v-model="form.last_name"/>
        </v-field>

        <v-field title="Date Of Birth" :error="error('dob')">
          <v-date-pick class="tw-form-input" displayFormat="DD-MM-YYYY" v-model="form.dob"/>
        </v-field>

        <button class="tw-rounded tw-bg-secondary cursor:tw-bg-secondary-cursor tw-px-6 tw-py-3 tw-font-bold tw-text-2xl tw-text-light tw-mx-8 tw-my-5">Save</button>

      </form>

    </profile-card>

    <profile-card title="Contact Info">
      <form v-on:submit.prevent="submitContact">

        <v-field title="Mobile Number" required :error="contactError('mobile_number')">
          <v-tel type="text" class="tw-form-input" v-model="contactForm.mobile_number"
            :enabledCountryCode="false" :dynamicPlaceholder="true" :inputOptions="{ showDialCode: true}"/>
        </v-field>

        <v-field title="Phone Number" required :error="contactError('phone_number')">
          <v-tel type="text" class="tw-form-input" v-model="contactForm.phone_number"
            :enabledCountryCode="false" :dynamicPlaceholder="true" :inputOptions="{ showDialCode: true}"/>
        </v-field>

        <button class="tw-rounded tw-bg-secondary cursor:tw-bg-secondary-cursor tw-px-6 tw-py-3 tw-font-bold tw-text-2xl tw-text-light tw-mx-8 tw-my-5">Save</button>

      </form>

    </profile-card>
  </div>
</template>

<script>
  import _ from "lodash";

  export default {
    props: {
      user: {},
    },
    data: v => ({
      loadingUsernameAvailability: false,
      usernameAvailabilityResponse: null,
      thumbnail: v.user.mid_avatar2,
      form: {
        username: v.user.username,
        first_name: v.user.first_name,
        last_name: v.user.last_name,
        avatar: null,
        reset_avatar: 0,
        dob: v.user.dob,
      },
      contactForm: {
        mobile_number: v.user.mobile_number,
        phone_number: v.user.phone_number,
      },
      errors: {},
      contactErrors: {},
    }),
    created() {
      this.$watch('form.username', value => {
        this.loadingUsernameAvailability = true
        axios.get('/api/v1/username-availability', {
          params: {username: value}
        })
          .then(resp => {
            this.usernameAvailabilityResponse = resp.data
          }).finally(() => this.loadingUsernameAvailability = false)
      })
    },
    methods: {
      error(key) {
        return _.get(this.errors, `${key}.0`, false)
      },
      contactError(key) {
        return _.get(this.contactErrors, `${key}.0`, false)
      },
      toBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        })
      },
      removeAvatar() {
        this.thumbnail = this.user.default_avatar
        this.form.avatar = null
        this.form.reset_avatar = 1
      },
      setAvatar(event) {
        let file = event.target.files[0];
        this.toBase64(file).then(url => this.thumbnail = url)
        this.form.avatar = file
      },
      submit() {
        let formData = new FormData();
        _.forEach(this.form, (value, key) => {
          if (value !== null){
            formData.append(key, value)
          }
        })
        axios({
          method: 'post',
          url: `/api/v1/profile?api_token=${this.user.api_token}`,
          data: formData,
          headers: {'Content-Type': 'multipart/form-data'}
        })
          .then(resp => {
            // update props `user` with `resp.data.resource`
            Vue.$toast.success(resp.data.message)
            this.errors = {}
            location.reload();

          })
          .catch(err => {
            if (err.response && err.response.status === 422) {
              this.errors = err.response.data.errors
            }
          })
      },
      submitContact() {
        axios({
          method: 'post',
          url: `/api/v1/profile/contact?api_token=${this.user.api_token}`,
          data: this.contactForm,
        })
          .then(resp => {
            this.contactErrors = {}
            Vue.$toast.success(resp.data.message)
          })
          .catch(err => {
            if (err.response && err.response.status === 422) {
              this.contactErrors = err.response.data.errors
            }
          })
      }
    }
  }
</script>
